import { TextComponent } from './TextComponent';
interface BackButtonProps {
    title: string;
    icon?: JSX.Element;
    onClick?: () => void;
    className?: string;
}
export const ButtonSecondary = ({ title, icon, onClick, className }: BackButtonProps) => {
    return (
        <button
            onClick={onClick}
            className={`flex gap-3 p-3 items-center text-primary transition-colors duration-300 ease-in-out bg-primaryLight rounded-md hover:bg-pink/40 ${className} select-none`}
        >
            {icon}
            <TextComponent variant="h5" className="max-md:hidden">
                {title}
            </TextComponent>
        </button>
    )
}
